module.exports = __webpack_public_path__ + "img/cocopay-logo-colored.5efef488.png";